'use-strict'
let subscribers = {}

function refreshCartDrawer() {
  return new Promise((res, rej) => {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function () {
        // 将更新后的购物车内容渲染到购物车抽屉的显示区域
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh:opend', { bubbles: true })
        )
        res(true)
      },
      error() {
        rej(false)
      },
    })
  })
}

async function addStarProduct(data, cb) {
  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  const json = await response.json()
  if (cb) cb()
  return await refreshCartDrawer(json)
}

window.addStarProduct = addStarProduct

var getScrollBarWidth = (function () {
  return {
    init: function () {
      var scrollDiv = document.createElement('div')
      scrollDiv.style.width = '100px'
      scrollDiv.style.height = '100px'
      scrollDiv.style.overflow = 'scroll'
      scrollDiv.style.position = 'absolute'
      scrollDiv.style.top = '-9999px'
      document.body.appendChild(scrollDiv)
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    },
  }
})()
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback]

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter(cb => {
      return cb !== callback
    })
  }
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach(callback => {
      if (data) {
        callback(data)
      } else {
        callback()
      }
    })
  }
}

function initLazyloadItem() {
  const lazyVideos = document.querySelectorAll('video.lazy-video-item')

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target
          const isImgSingle = video.classList.contains('img-single')

          if (isImgSingle) {
            const sources = JSON.parse(video.dataset.sources)
            const sourceEl = document.createElement('source')
            if (window.luteUtil.isMobile && sources.mobile) {
              sourceEl.setAttribute('src', sources.mobile)
            } else {
              sourceEl.setAttribute('src', sources.desktop)
            }
            video.appendChild(sourceEl)
            video.classList.remove('lazy-video-item')
            if (isImgSingle) video.classList.add('lazy-video-loaded')
            video.load()
            observer.unobserve(video)
            return
          }

          const poster = video.dataset.poster
          const src = video.dataset.src

          if (poster) {
            video.setAttribute('poster', poster)
            video.removeAttribute('data-poster')
            video.setAttribute('src', src)
            video.removeAttribute('data-src')
          }

          video.querySelectorAll('source').forEach(source => {
            const source_src = source.dataset.src
            if (source_src) {
              source.setAttribute('src', source_src)
              source.removeAttribute('data-src')
            }
          })

          video.classList.remove('lazy-video-item')
          observer.unobserve(video) // Stop observing once loaded
        }
      })
    },
    { threshold: 0.1 } // Trigger when 10% of the video is visible
  )

  lazyVideos.forEach(video => observer.observe(video))
}

// Initialize lazy loading item
initLazyloadItem()

var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady()
    },
    imageLoad(entry, observer) {
      const onImageLoad = e => {
        const target = e.currentTarget
        setTimeout(() => {
          target?.closest('motion-element')?.classList.remove('bls-loading-image')
          target?.classList.remove('bls-loading-image')
        }, 600)
        e.currentTarget.removeEventListener('load', onImageLoad)
      }
      entry.target.width = entry.boundingClientRect.width
      entry.target.height = entry.boundingClientRect.height
      entry.target.sizes = `${entry.boundingClientRect.width}px`
      entry.target.addEventListener('load', onImageLoad)
      observer.unobserve(entry.target)
    },
    bgLoad(entry, observer) {
      const bg = entry.target.getAttribute('data-bg')
      if (bg) entry.target.style.setProperty('--bg-image', `url('${bg}')`)
      observer.unobserve(entry.target)
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                if (entry.target.tagName == 'IMG') {
                  this.imageLoad(entry, observer)
                } else {
                  this.bgLoad(entry, observer)
                }
              }
            })
          },
          { rootMargin: '10px' }
        )
        document.querySelectorAll('.bls-image-js img').forEach(img => {
          observer.observe(img)
        })
        document.querySelectorAll('[data-bg]').forEach(img => {
          if (img.getAttribute('data-bg') && img.getAttribute('data-bg').length > 0)
            observer.observe(img)
        })
      }
    },
  }
})()
BlsLazyloadImg.init()
function CloseAllPopup(data) {
  publish('closeCanvas', data)
}

let parser = new DOMParser()

const ON_CHANGE_DEBOUNCE_TIMER = 300

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
}
const imageReady = imageOrArray => {
  if (!imageOrArray) {
    return Promise.resolve()
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray)
  return Promise.all(
    imageOrArray.map(image => {
      return new Promise(resolve => {
        if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
          setTimeout(() => {
            image.closest('motion-element')?.classList.remove('bls-loading-image')
            image.classList.remove('bls-loading-image')
            resolve()
          }, 100)
        } else {
          image.addEventListener('load', e => {
            e.currentTarget.closest('motion-element')?.classList.remove('bls-loading-image')
            e.currentTarget.classList.remove('bls-loading-image')
            resolve()
          })
        }
      })
    })
  )
}

function isSafariBrowser() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}
class WWTabItems extends HTMLElement {
  constructor() {
    super()
    this.tabs = this.querySelectorAll('.ww-tab__tab-item')
    this.select = this.querySelector('.ww-tab__select-tab')
    this.content = this.querySelectorAll('.ww-tab__tab-content')
    this.init()

    if (Shopify.designMode) {
      this.tabNav = this.querySelector('tabs-navigation')
      this.addEventListener('shopify:block:select', function (e) {
        const hasEl = [...this.content].find(el => e.target === el || el.contains(e.target))
        if (!hasEl) return
        const tab = [...this.tabs].find(t => t.dataset.blockId == hasEl.dataset.blockId)
        this.tabNav.activateTab(tab.dataset.blockId, tab)
        this.onClick(tab)
      })
    }
  }
  init() {
    const self = this
    this.tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        self.onClick(this)
      })
    })
  }
  onClick(tab) {
    if (!tab) return
    const blockId = tab.dataset.blockId
    console.log('🚀 ~ blockId:', blockId)
    this.showContent(blockId)
    this.tabs.forEach(t => {
      t.classList.remove('active')
    })
    tab.classList.add('active')
  }

  showContent(blockId) {
    this.content.forEach(content => {
      if (content.dataset.blockId === blockId) {
        content.classList.add('active')
        let motion_element = content.querySelectorAll('motion-element')
        motion_element.forEach(motion => {
          motion.refreshAnimation()
        })
      } else {
        content.classList.remove('active')
      }
    })
  }
}
customElements.define('ww-tab-items', WWTabItems)

class SlideSection extends HTMLElement {
  constructor() {
    super()
    this.globalSlide = null
    setTimeout(() => {
      this.init()
    }, 50)
  }

  init() {
    if (document.body.classList.contains('index')) {
      let pos = window.pageYOffset
      if (pos > 0 || document.body.classList.contains('swiper-lazy')) {
        this.initSlide()
      } else {
        if (this.classList.contains('lazy-loading-swiper-before')) {
          this.initSlide()
        } else {
          this.classList.add('lazy-loading-swiper-after')
        }
      }
    } else {
      this.initSlide()
    }
  }

  initSlide() {
    const _this = this
    var autoplaying = _this?.dataset.autoplay === 'true'
    const loop = _this?.dataset.loop === 'true'
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : ''
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1
    const direction = _this?.dataset.direction ? _this?.dataset.direction : 'horizontal'
    var autoplaySpeed = _this?.dataset.autoplaySpeed ? _this?.dataset.autoplaySpeed * 1000 : 3000
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400
    const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide'
    const row = _this?.dataset.row ? _this?.dataset.row : 1
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30
    var mobile_spacing = _this?.dataset.mobileSpacing ? _this?.dataset.mobileSpacing : spacing
    const progressbar = _this?.dataset.paginationProgressbar === 'true'
    const autoItem = _this?.dataset.itemMobile === 'true'
    const autoHeight = _this?.dataset.autoHeight === 'true'
    const arrowCenterimage = _this?.dataset.arrowCenterimage ? _this?.dataset.arrowCenterimage : 0
    const nextEl = document.querySelector(_this.dataset.nextEl)
    const prevEl = document.querySelector(_this.dataset.prevEl)
    spacing = Number(spacing)
    mobile_spacing = Number(mobile_spacing)
    autoplaySpeed = Number(autoplaySpeed)
    speed = Number(speed)
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed }
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1
      } else if (itemDesktop < 3) {
        itemTablet = 2
      } else {
        itemTablet = 3
      }
    }
    if (direction == 'vertical') {
      _this.style.maxHeight = _this.offsetHeight + 'px'
    }

    const defaultOption = {
      slidesPerView: autoItem ? 'auto' : itemMobile,
      spaceBetween: mobile_spacing >= 15 ? 15 : mobile_spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: 'row',
      },
      navigation: {
        nextEl: nextEl || _this.querySelector('.swiper-button-next, .swiper-nav-next'),
        prevEl: prevEl || _this.querySelector('.swiper-button-prev, .swiper-nav-prev'),
      },
      pagination: {
        clickable: true,
        el: _this.querySelector('.parent-pagination') || _this.querySelector('.swiper-pagination'),
        type: progressbar ? 'progressbar' : 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest('.sec__tiktok-video')
          if (_this.classList.contains('slideshow')) {
            const motionElement = _this.querySelectorAll(
              `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup`
            )
            setTimeout(() => {
              motionElement &&
                motionElement.forEach(item => {
                  item.refreshAnimation()
                })
            }, 350)
          }
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)'
          )
          slide_visibles?.forEach(slide => {
            if (slide && typeof slide.initialize === 'function') {
              slide.initialize()
            }
          })
          e.autoplay.stop()
          if (_this?.dataset.autoplay === 'true') {
            motion.inView(
              _this,
              async () => {
                e.autoplay.start()
              },
              { margin: '0px 0px -50px 0px' }
            )
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok)
            window.addEventListener('resize', function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok)
              }, 150)
            })
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll('.product-item__media--ratio')
            if (items_slide.length != 0) {
              var oH = []
              items_slide.forEach(e => {
                oH.push(e.offsetHeight / 2)
              })
              var max = Math.max(...oH)
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px'
              if (_this.querySelectorAll('.swiper-arrow')) {
                _this.querySelectorAll('.swiper-arrow').forEach(arrow => {
                  arrow.setAttribute('style', arrowsOffset)
                })
              }
            }
          }
          var video = _this.querySelector('video.slideshow')
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return
              observer.unobserve(_this)
              const videos = _this.querySelectorAll('video')
              videos.forEach(video => {
                const dataSrc = video.dataset.src
                if (dataSrc) {
                  video.src = dataSrc
                  video.removeAttribute('data-src')
                }
              })
            }
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: '0px 0px 200px 0px',
            }).observe(_this)
          }
        },
        realIndexChange: function (swiper) {
          if (_this?.dataset.autoplay) {
            var slide_visibles = _this.querySelectorAll(
              '.swiper-slide motion-element:not([data-image])'
            )
            slide_visibles?.forEach(slide => {
              if (!slide.hasAttribute('hold')) {
                slide?.setAttribute('hold', true)
              }
            })
          } else {
            var slide_visibles = _this.querySelectorAll(
              '.swiper-slide motion-element:not([data-image])'
            )
            slide_visibles?.forEach(slide => {
              if (!slide.hasAttribute('hold')) {
                slide?.setAttribute('hold', true)
              }
            })
          }

          setTimeout(() => {
            if (_this.classList.contains('slideshow')) {
              const motionElement = _this.querySelectorAll(
                `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup, .swiper-slide.swiper-slide-active  motion-element.motion-image`
              )
              motionElement &&
                motionElement.forEach(item => {
                  item.refreshAnimation()
                })
            }
          }, 50)
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1
          if (_this.closest('.sec__testimonials-single')) {
            const allDots = _this
              .closest('.sec__testimonials-single')
              .querySelectorAll(`single-item`)
            allDots.forEach(dot => {
              dot.classList.remove('active')
            })
            _this
              .closest('.sec__testimonials-single')
              .querySelector(
                ".testimonials-author-image[data-position='" + index_currentSlide + "']"
              )
              .classList.add('active')
          }
        },
        afterInit() {
          _this.dispatchEvent(new Event('afterInit', { detail: _this.globalSlide }))
        },
      },
    }
    let additionalSwiperOptions = {}
    if (_this?.dataset.swiperOptions) {
      if (_this?.dataset.swiperOptions.trim().charAt(0) === '{') {
        additionalSwiperOptions = JSON.parse(_this?.dataset.swiperOptions)
      } else if (_this?.dataset.swiperOptions.startsWith('window.')) {
        additionalSwiperOptions = window[_this?.dataset.swiperOptions.slice(7)]
      } else if (_this?.dataset.swiperOptions.startsWith('window[')) {
        const key = _this?.dataset.swiperOptions.match(/window\[['"](.+?)['"]\]/)[1]
        additionalSwiperOptions = window[key]
      }
    }
    const swiperOptions = { ...defaultOption, ...additionalSwiperOptions }

    this.globalSlide = new Swiper(_this, swiperOptions)
  }

  initSecTiktok(sec) {
    sec.querySelectorAll('.swiper-slide').forEach(arrow => {
      const tiktok = arrow.querySelector('.section_tiktok-image')
      let width = '--item-width: ' + arrow.offsetWidth
      tiktok.setAttribute('style', width)
    })
  }
}
customElements.define('slide-section', SlideSection)

const root = document.body
class PopupBase extends HTMLElement {
  constructor() {
    super()
    this.customClass = this.dataset.customClass
    this.modal = null
  }

  initPopup(content, text, customClass) {
    const _this = this
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        root.classList.add('open-popup')
        root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px')
        const video = this.modalBox.querySelector('video')
        if (!video) return
        video.play()
        if (this.modal.classList.contains('shopable-video')) {
          video.muted = false
        }
      },
      onClose: function () {},
      beforeClose: function () {
        _this.onCloseEvent()
        setTimeout(() => {
          root.classList.remove('open-popup')
          root.style.removeProperty('padding-right')
        }, 4)
        return true
      },
    })
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent
      let popup_header = document.createElement('div')
      popup_header.classList.add('tingle-modal-box__header')
      popup_header.innerHTML = content
      let parentElement = popup_content.parentNode
      parentElement.insertBefore(popup_header, popup_content)
    }
    if (text) {
      this.modal.setHeader(text)
    }

    this.modal.setContent(content)
    this.modal.open()
  }

  onClose() {
    this.modal.close()
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super()
    this.options = null
    this.init()
  }

  init() {
    const _this = this
    this.querySelectorAll('.product__color-swatches--js').forEach(btn => {
      _this.checkSwatches(btn)
    })
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } = e.dataset
    if (color) {
      if (swatchType != 'variant_images') {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color
            e.classList.add(customValue)
          } else {
            e.classList.add(customValue)
            if (image) {
              e.classList.add('color__' + color.replaceAll(' ', '-'))
              e.style.backgroundColor = null
              e.style.backgroundImage = "url('" + image + "')"
              e.style.backgroundSize = 'cover'
              e.style.backgroundRepeat = 'no-repeat'
            }
          }
        } else {
          e.style.setProperty('--swatch--background', optionSwatchValue)
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add('color__' + color.replaceAll(' ', '-'))
            e.style.backgroundColor = null
            e.style.backgroundImage = "url('" + image + "')"
            e.style.backgroundSize = 'cover'
            e.style.backgroundRepeat = 'no-repeat'
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color
            e.classList.add(customValue)
          } else {
            e.classList.add(customValue)
          }
        } else {
          e.style.setProperty('--swatch--background', optionSwatchValue)
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style
    s.color = strColor
    return s.color == strColor
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('.product__color-swatches--js.active'),
      select => select.getAttribute('data-value')
    )
    this.variantData.find(variant => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        }
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options
        }
      }
    })
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    }))
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'))
      if (focus) deferredElement.focus()
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play()
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`
  fetch(url)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const elementErrorMessage = html.querySelector('.product-form__error-message-wrapper')
      const elementMessage = elementErrorMessage.querySelector('.product-form__error-message')
      elementMessage.textContent = errorMessage
      showToast(elementErrorMessage.innerHTML, 5000, 'modal-error')
    })
    .catch(e => {
      throw e
    })
}

function showToast(message, duration = 3000, customClass = '') {
  let toastContainer = document.getElementById('toast-container')
  if (!toastContainer) {
    toastContainer = document.createElement('div')
    toastContainer.id = 'toast-container'
    document.body.appendChild(toastContainer)
  }

  const toast = document.createElement('div')
  toast.className = `toast show ${customClass}`
  toast.innerHTML = message
  toastContainer.appendChild(toast)

  setTimeout(() => {
    closeToast(toast)
  }, duration)
}

function closeToast(toast) {
  toast.classList.remove('show')
  setTimeout(() => {
    toast.remove()
    if (!document.querySelector('#toast-container .toast')) {
      document.getElementById('toast-container').remove()
    }
  }, 500)
}

class SlideLazyLoad {
  constructor(e) {
    ;(this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] })
  }
  triggerListenerJs() {
    this._removeUserInteractionListenerJs(this),
      'loading' === document.readyState
        ? document.addEventListener('DOMContentLoaded', this._loadEverythingReadyNow.bind(this))
        : this._loadEverythingReadyNow()
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach(t =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    )
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach(t =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    )
  }
  _preloadAllScriptsJs() {
    document.body.classList.add('swiper-lazy')
    document.body.classList.add('review-lazy')
    const loadingSwiper = document.querySelectorAll('.lazy-loading-swiper-after')
    loadingSwiper.forEach(el => {
      el.classList.remove('lazy-loading-swiper-after')
      this.initSlide(el)
    })
    const reviewProduct = document.querySelectorAll('.review-product-added')
    reviewProduct.forEach(el => {
      el.classList.remove('review-product-added')
      el.innerHTML = el.querySelector('.product-review-json').innerHTML
      el.classList.remove('inline-loading')
    })
  }

  initSlide(el) {
    const _this = el
    var autoplaying = _this?.dataset.autoplay === 'true'
    const loop = _this?.dataset.loop === 'true'
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : ''
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1
    const direction = _this?.dataset.direction ? _this?.dataset.direction : 'horizontal'
    var autoplaySpeed = _this?.dataset.autoplaySpeed ? _this?.dataset.autoplaySpeed * 1000 : 3000
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400
    const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide'
    const row = _this?.dataset.row ? _this?.dataset.row : 1
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30
    const progressbar = _this?.dataset.paginationProgressbar === 'true'
    const autoItem = _this?.dataset.itemMobile === 'true'
    const arrowCenterimage = _this?.dataset.arrowCenterimage ? _this?.dataset.arrowCenterimage : 0
    spacing = Number(spacing)
    autoplaySpeed = Number(autoplaySpeed)
    speed = Number(speed)
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed }
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1
      } else if (itemDesktop < 3) {
        itemTablet = 2
      } else {
        itemTablet = 3
      }
    }
    if (direction == 'vertical') {
      _this.style.maxHeight = _this.offsetHeight + 'px'
    }
    _this.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? 'auto' : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: 'row',
      },
      navigation: {
        nextEl: _this.querySelector('.swiper-button-next'),
        prevEl: _this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el: _this.querySelector('.parent-pagination') || _this.querySelector('.swiper-pagination'),
        type: progressbar ? 'progressbar' : 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          pagination: {
            type: progressbar ? 'progressbar' : 'bullets',
          },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: {
            type: progressbar ? 'progressbar' : 'bullets',
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)'
          )
          slide_visibles?.forEach(slide => {
            slide?.initialize()
          })
          e.autoplay.stop()
          if (_this?.dataset.autoplay === 'true') {
            motion.inView(
              _this,
              async () => {
                e.autoplay.start()
              },
              { margin: '0px 0px -50px 0px' }
            )
          }
          var sec__tiktok = _this.closest('.sec__tiktok-video')
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok)
            window.addEventListener('resize', function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok)
              }, 150)
            })
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll('.product-item__media--ratio')
            if (items_slide.length != 0) {
              var oH = []
              items_slide.forEach(e => {
                oH.push(e.offsetHeight / 2)
              })
              var max = Math.max(...oH)
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px'
              if (_this.querySelectorAll('.swiper-arrow')) {
                _this.querySelectorAll('.swiper-arrow').forEach(arrow => {
                  arrow.setAttribute('style', arrowsOffset)
                })
              }
            }
          }
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide motion-element:not([data-image])'
          )
          slide_visibles?.forEach(slide => {
            if (!slide.hasAttribute('hold')) {
              slide?.setAttribute('hold', true)
            }
          })
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1
          if (_this.closest('.sec__testimonials-single')) {
            const allDots = _this
              .closest('.sec__testimonials-single')
              .querySelectorAll(`single-item`)
            allDots.forEach(dot => {
              dot.classList.remove('active')
            })
            _this
              .closest('.sec__testimonials-single')
              .querySelector(
                ".testimonials-author-image[data-position='" + index_currentSlide + "']"
              )
              .classList.add('active')
          }
        },
      },
    })
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event('glozinspeed-allScriptsLoaded'))
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift()
    return t ? (await this._transformScript(t), this._loadScriptsFromListJs(e)) : Promise.resolve()
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise(t => {
        const s = document.createElement('script')
        let n
        ;[...e.attributes].forEach(e => {
          let t = e.nodeName
          'type' !== t &&
            ('data-glozinlazy-type' === t && ((t = 'type'), (n = e.nodeValue)),
            s.setAttribute(t, e.nodeValue))
        }),
          e.hasAttribute('src')
            ? (s.addEventListener('load', t), s.addEventListener('error', t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e)
      })
    )
  }
  async _triggerDOMContentLoadedJs() {
    ;(this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event('glozinspeed-DOMContentLoaded')),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-DOMContentLoaded')),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event('glozinspeed-readystatechange')),
      await this._requestAnimFrame(),
      document.glozinonreadystatechange && document.glozinonreadystatechange()
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-load')),
      await this._requestAnimFrame(),
      window.glozinonload && window.glozinonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-pageshow')),
      await this._requestAnimFrame(),
      window.glozinonpageshow && window.glozinonpageshow()
  }
  async _requestAnimFrame() {
    return new Promise(e => requestAnimationFrame(e))
  }
  static run() {
    const e = new SlideLazyLoad([
      'keydown',
      'mousemove',
      'touchmove',
      'touchstart',
      'touchend',
      'wheel',
    ])
    e._addUserInteractionListenerJs(e)
  }
}
SlideLazyLoad.run()

class slideLine extends HTMLElement {
  constructor() {
    super()
    this.slideItems = null
  }

  static observedAttributes = ['data-active']
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-active' && newValue === 'true') {
      this.init()
    }
  }

  connectedCallback() {
    if (this.hasAttribute('data-active')) {
      return
    }
    this.init()
  }

  init() {
    const line = document.createElement('div')
    line.className = 'line slider-line'
    this.appendChild(line)

    this.slideItems = this.querySelectorAll('.slide-item')
    this.updateLinePosition()
    this.watchActiveItem()
  }

  updateLinePosition() {
    let activeItem = this.querySelector('.slide-item.active')
    if (!activeItem) {
      activeItem = this.slideItems[0]
    }
    const line = this.querySelector('.slider-line')

    const { offsetLeft, offsetWidth } = activeItem
    const clipLeft = offsetLeft
    const clipRight = offsetLeft + offsetWidth
    const containerOffsetWidth = this.offsetWidth
    const right = Number(100 - (clipRight / containerOffsetWidth) * 100).toFixed()
    const left = Number((clipLeft / containerOffsetWidth) * 100).toFixed()
    line.style.clipPath = `inset(0 ${right}% 0 ${left}% round 99px)`
  }

  watchActiveItem() {
    const observer = new MutationObserver(() => {
      this.updateLinePosition()
    })

    this.slideItems.forEach(item => {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] })
    })
  }
}
customElements.define('slide-line', slideLine)

let dealToastTemp = null
class Deal25Toast extends HTMLElement {
  constructor() {
    super()
    this.message = this.dataset.message || ''
    this.url = `${window.location.pathname}?section_id=deal25-toast`
    this.timer = null
    this.host = null
  }

  connectedCallback() {
    if (!document.head.querySelector('#deal25-toast')) {
      this.preloadFetch(this.url)
    }
    this.registeEvent()
  }

  handleCopy(text) {
    if (isSafariBrowser() || !navigator.clipboard) {
      const input = document.createElement('textarea')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      input.style.top = '-1000px'
      input.value = text
      document.body.appendChild(input)
      setTimeout(() => {
        input.focus()
        input.select()
        const ok = document.execCommand('copy')
        input.remove()
        if (!ok) {
          throw new Error('Copy command was unsuccessful')
        }
      }, 4)
      return
    }
    navigator.clipboard.writeText(text)
  }
  handleClick(e) {
    const target = e.target
    const msg = target.dataset.toast || this.message
    const duration = this.dataset.duration ? parseInt(this.dataset.duration) : 2500

    let beforeCb = () => {
      if (target.dataset.code) this.handleCopy(target.dataset.code)
    }
    const cb = () => {
      if (target.dataset.href) window.location.href = target.dataset.href
    }

    this.show(msg, { duration: duration, beforeCb, cb })
  }

  registeEvent() {
    this.clickEvent = this.handleClick.bind(this)
    const triggerEl = this.querySelectorAll('[data-toast]')
    if (!triggerEl) return
    triggerEl.forEach(el => {
      el.addEventListener('click', this.clickEvent)

      if (el.dataset.href) {
        el.addEventListener(
          'mouseenter',
          () => {
            this.prerenderPage(el.dataset.href)
          },
          { once: true }
        )

        el.addEventListener(
          'touchstart',
          () => {
            this.prerenderPage(el.dataset.href)
          },
          { once: true }
        )
      }
    })
  }

  preloadFetch(link) {
    const styleEl = document.createElement('link')
    styleEl.setAttribute('rel', 'preload')
    styleEl.setAttribute('href', link)
    styleEl.setAttribute('as', 'fetch')
    styleEl.setAttribute('crossorigin', 'anonymous')
    styleEl.setAttribute('id', 'deal25-toast')
    document.head.appendChild(styleEl)
  }

  prerenderPage(link) {
    const linkElem = document.createElement('link')
    linkElem.rel = 'prefetch'
    linkElem.href = link
    document.head.append(linkElem)
  }

  async getToast(msg) {
    if (!dealToastTemp) {
      const responseText = await fetch(this.url).then(response => response.text())
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const tempEl = html.querySelector('#deal25-toast')
      const styleEl = tempEl.querySelector('style')
      if (styleEl && !document.head.querySelector('style#deal25-toast-style')) {
        document.head.appendChild(styleEl.cloneNode(true))
      }
      dealToastTemp = tempEl.querySelector('#deal25-toast-html')
    }
    let toastEl = null
    toastEl = dealToastTemp.cloneNode(true)
    if (msg) {
      const textHemlEl = toastEl.querySelector('.text')
      textHemlEl.textContent = msg
    }

    return toastEl
  }

  hide() {
    this.host.classList.remove('show')
    clearTimeout(this.timer)
    this.timer = null
    this.host.hidden = true
  }

  appendToaset() {
    if (window.innerWidth < 768) {
      document.body.appendChild(this.host)
    } else {
      this.appendChild(this.host)
    }
  }

  async show(message = this.message, opts) {
    const _that = this
    opts = opts || {}
    if (this.host) {
      if (this.host.classList.contains('show')) {
        this.hide()
      }
    } else {
      this.host = await this.getToast(message)
      this.appendToaset()
    }
    this.host.hidden = false
    setTimeout(() => {
      this.host.classList.add('show')
    }, 20)
    clearTimeout(this.timer)
    if (opts.beforeCb) {
      opts.beforeCb()
    }
    let duration = typeof opts.duration === 'number' ? opts.duration : 2500
    this.timer = setTimeout(() => {
      _that.hide()
      opts.cb && opts.cb()
    }, duration)
  }
}

customElements.define('deal25-toast', Deal25Toast)

class LoginCheck extends HTMLElement {
  constructor() {
    super()
    this.loginDialog = document.querySelector('login-dialog')
  }

  init() {
    this.addEventListener('click', this.clickEvent, true)
  }

  connectedCallback() {
    this.loginType = this.dataset.loginType || 'modal'
    this.clickEvent = this.onClick.bind(this)
    this.watchLoginEvent()
    this.init()
  }

  showHiddenEl() {
    this.querySelectorAll('[data-login-show]').forEach(el => {
      el.classList.remove('hidden')
    })
  }

  watchLoginEvent() {
    document.addEventListener('LUTE:AUTH:LOGIN', e => {
      this.removeEventListener('click', this.clickEvent, true)
      this.showHiddenEl()
    })
  }

  onClick(e) {
    if (e.target.hasAttribute('data-login')) {
      e.preventDefault()
      e.stopPropagation()
      if (this.loginType === 'link') {
        const link =
          this.dataset.link ||
          `${window.__MC__CONFIG__.accountSiteUrl}/login?redirect=https://momcozy.com&source=shopify-site`
        window.location.href = link
        return
      }
      const loginDialog = document.querySelector('login-dialog')
      loginDialog?.open()
    }
  }
}

customElements.define('login-check', LoginCheck)

const slideAnime = (() => {
  let isAnimating = false

  return setOptions => {
    const defaultOptions = {
      target: false,
      animeType: 'slideToggle',
      duration: 250,
      easing: 'ease',
      isDisplayStyle: 'block',
      parent: false,
      addFunction: () => {},
    }
    const options = Object.assign({}, defaultOptions, setOptions)
    const target = options.target
    const ownAnimate = options.ownAnimate
    if (ownAnimate) {
      isAnimating = false
    }
    const parent = options.parent
    if (!target) {
      return
    }

    if (isAnimating) {
      return
    }
    isAnimating = true
    parent.classList?.toggle('opened')

    let animeType = options.animeType
    const styles = getComputedStyle(target)
    if (animeType === 'slideToggle') {
      animeType = styles.display === 'none' ? 'slideDown' : 'slideUp'
    }
    if (
      (animeType === 'slideUp' && styles.display === 'none') ||
      (animeType === 'slideDown' && styles.display !== 'none') ||
      (animeType !== 'slideUp' && animeType !== 'slideDown')
    ) {
      isAnimating = false
      return false
    }
    target.style.overflow = 'hidden'
    const duration = options.duration
    const easing = options.easing
    const isDisplayStyle = options.isDisplayStyle

    if (animeType === 'slideDown') {
      target.style.display = isDisplayStyle
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + 'px',
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    }

    Object.keys(heightVal).forEach(key => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key]
      }
    })
    if (Object.keys(heightVal).length === 0) {
      isAnimating = false
      return false
    }
    let slideAnime
    if (animeType === 'slideDown') {
      Object.keys(heightVal).forEach(key => {
        target.style[key] = 0
      })
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      })
    } else if (animeType === 'slideUp') {
      Object.keys(heightVal).forEach(key => {
        target.style[key] = heightVal[key]
        heightVal[key] = 0
      })
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      })
    }
    slideAnime.finished.then(() => {
      options.addFunction()
      target.style.overflow = ''
      Object.keys(heightVal).forEach(key => {
        target.style[key] = ''
      })
      if (animeType === 'slideUp') {
        target.style.display = 'none'
      }
      isAnimating = false
    })
  }
})()

class CollapsibleBlock extends HTMLElement {
  constructor() {
    super()
    const _this = this
    const block = _this.querySelectorAll('.collapsible-heading')
    block.forEach(event => {
      event.addEventListener('click', e => {
        const target = e.currentTarget
        const parent = target.parentElement
        const footerContent = parent.querySelector('.collapsible-content')
        if (
          _this.closest('.collection-filter') &&
          _this.closest('.collection-filter').classList.contains('horizontal') &&
          window.innerWidth > 1024
        ) {
          if (!_this.classList.contains('active')) {
            if (document.querySelector('collapsible-block.active')) {
              document.querySelector('collapsible-block.active').classList.remove('active')
            }
            _this.classList.add('active')
          } else {
            _this.classList.remove('active')
          }
        } else {
          slideAnime({
            target: footerContent,
            animeType: 'slideToggle',
          })
          if (!_this.classList.contains('active')) {
            _this.classList.add('active')
          } else {
            _this.classList.remove('active')
          }
        }
      })
    })
    document.body.addEventListener('click', this.handleBodyClick.bind(this))
    if (this.classList.contains('collection')) {
      this.actionInMobile()
      window.addEventListener('resize', () => {
        this.actionInMobile()
      })
    }
  }

  actionInMobile() {
    var _this = this
    var width = window.innerWidth
    if (width <= 1024) {
      const footerContent = _this.querySelector('.collapsible-content')
      if (footerContent) footerContent.style.display = 'block'
      _this.classList.add('active')
    }
  }

  handleBodyClick(evt) {
    const target = evt.target
    if (
      target != this &&
      !target.closest('collapsible-block') &&
      document.querySelector('.collection-filter') &&
      document.querySelector('.collection-filter').classList.contains('horizontal') &&
      window.innerWidth > 1024
    ) {
      const block = document
        .querySelector('.collection-filter')
        .querySelectorAll('collapsible-block')
      block.forEach(collapsible => {
        collapsible.classList.remove('active')
      })
    }
  }
}
customElements.define('collapsible-block', CollapsibleBlock)

class TabsLoadMore extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId
    this.param = this.dataset.param
    this.total = parseInt(this.dataset.total)
    this.count = parseInt(this.dataset.count)
    this.currentPage = 1
    this.paginationEl = this.querySelector('.t4s-prs-pagination')
    this.loadMoreBtn = this.querySelector('.t4s-loadmore-btn')
    this.currentPageEl = this.querySelector('[data-current-bar]')
    this.loadMoreBar = this.querySelector('.t4s-lm-bar--current')
    this.clickHandler = this.handleClick.bind(this)
    this.init()
  }

  init() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', this.clickHandler)
    }
  }

  handleClick(e) {
    e.preventDefault()
    this.loadMoreProducts()
  }

  getSectionInnerHTML(html, selector) {
    const blockEl = new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
    console.log('🚀 ~ blockEl:', blockEl)
    console.log('🚀 ~ blockEl?.dataset.offset:', blockEl?.dataset.offset)
    return {
      innerHtml: blockEl?.innerHTML || '',
      offset: blockEl?.dataset.offset || 0,
    }
  }

  updateEvents() {
    T4SThemeSP.reinitProductGridItem()
  }
  async loadMoreProducts() {
    if (this.currentPage >= this.total) return
    try {
      this.loadMoreBtn.classList.add('is--loading')

      const response = await fetch(
        `?section_id=${this.sectionId}&${this.param}=${this.currentPage + 1}`
      )
      if (!response.ok) return

      const data = await response.text()
      const { innerHtml, offset } = this.getSectionInnerHTML(
        data,
        `#${this.id} [data-contentlm-replace]`
      )

      if (innerHtml) {
        this.querySelector('[data-contentlm-replace]').insertAdjacentHTML('beforeend', innerHtml)
        this.currentPage++
        this.offset = offset
        this.updateEvents()
      }

      if (this.currentPage >= this.total) {
        this.paginationEl.remove()
      } else {
        this.currentPageEl.innerHTML = this.offset
        this.loadMoreBar.style.width = `${(this.offset / this.count) * 100}%`
      }
    } finally {
      this.loadMoreBtn.classList.remove('is--loading')
    }
  }
}

customElements.define('tabs-loadmore', TabsLoadMore)
